import inView from 'in-view';

function init () {
  const backgroundText = document.getElementById('background-text');
  inView.offset({
    top: 500,
    right: 0,
    bottom: 500,
    left: 0
  });
  inView('.threats')
    .on('enter', (el) => {
      backgroundText.classList.add('active');
    })
    .on('exit', (el) => {
      backgroundText.classList.remove('active');
    });
}

export default {
  init
};



// WEBPACK FOOTER //
// ./src/js/pages/invasive-species.js